module.exports = __webpack_public_path__ + "img/about_layout3.79cb78da.png";